import axios from "axios";
import { useEyeconxStore } from "../store/eyeconxStore";
import {jwtDecode} from "jwt-decode";

const axiosNew = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
})

axiosNew.interceptors.request.use(
    (config) =>{
        const token = useEyeconxStore.getState().token
        const uid = useEyeconxStore.getState().user?.ID 
        const clinicid = useEyeconxStore.getState().user?.clinicId
        const { exp } = jwtDecode(token)
        const logout = useEyeconxStore.getState().logout

        const expirationTime = (exp * 1000) - 60000
        if (Date.now() >= expirationTime) {
                
                // set LocalStorage here based on response;
            console.log("Token Expired")
            logout()
           //redirect window to login page 
            window.location.href = "/login"

        }
        if(token){
           // console.log("Token Set by Interceptor")
            config.headers.Authorization = "Bearer "+token;
        }
        if(uid){
            config.headers['X-User-ID'] = uid
        }
        if(clinicid){
            config.headers['X-Clinic-ID'] = clinicid
        }
        return config;
    },
    (error) =>{
        console.log("Error in Interceptor")
        return Promise.reject(error);
    }
)
export default axiosNew